import React, { useCallback, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Input, Typography, Divider, Radio, Modal, Popover } from 'antd';
// import forgotIcon from 'assets/images/reset-icon.svg';
import { useRecoverId, useForgetIdValidatepwd } from 'all-in-one-shared-api';
import PolicyAndMemberIdModal from './PolicyAndMemberIdModal';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Wrapper } from './styledComponents';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
// import { useContext } from 'react';
import Tab from './component/Tab';
import './style.less';
import { useLocation, useNavigate } from 'react-router-dom';
import { MobileNumberPrefix, PrimaryButton } from 'components';
import type { RadioChangeEvent } from 'antd';
import { setErrorCodeFun, newVerifyMobileNumber, VerifyEmail } from '../../../utils';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { EyeFilled, EyeInvisibleOutlined } from '@ant-design/icons';
import { useKeycloakReady } from 'hooks';
import LocationState from '../../../auth/LocationState';
import GoogleCaptcha from '../../../components/googleCaptcha';
import { getConfig } from 'configs';
import { localStorageService } from 'utils/LocalStorageService';
import './ForgotLoginPage.less';
export type FormData = {
  countryCode: string;
  email?: string;
  mobile?: string;
  policyNumber?: string;
  memberId?: string;
  dependant?: string;
  identityNo?: string;
  password?: string;
};
type DirectLoginFormData = {
  emailId: string;
  password?: string;
};
const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');
function ForgotLoginPage() {
  const { t, i18n } = useTranslation();
  const { keycloak, tokenParsed, initialized } = useKeycloakReady();
  const [isCaptchaVerified, setCaptchaVerified] = React.useState(false);
  const [isShowError, setShowError] = React.useState(false);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [selectType, setSelectType] = useState(0);
  const [loginFailCount, setLoginFailCount] = React.useState(0);
  const [shouldPassword, setShouldPassword] = useState(false);
  const [loginId, setLoginId] = useState('');
  const [recoverIdError1, setRecoverIdError1] = useState('');
  const [visible, setVisible] = useState(false);
  const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const location = useLocation();
  const [forgotBtn, setForgotBtn] = React.useState(false);
  const [randoms, setRandoms] = useState(0);
  const [randoms1, setRandoms1] = useState(0);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [tipShow, setTipShow] = useState(false);
  const [errors, setErrors] = useState<string | null>(null);
  const [errorPwd, setErrorPwd] = useState<string | null>(null);
  const [errorsmsg, setErrorsmsg] = useState<string>('');
  const from: string = (location.state as LocationState)?.from?.pathname || '/home';
  const [form1, setForm1] = useState((): FormData => {
    return {
      email: '',
      mobile: '',
      countryCode: '+852',
      policyNumber: '',
      memberId: '',
      dependant: '0',
      identityNo: '',
      password: '',
    };
  });

  const {
    shouldFetch: recoverIdShouldFetch,
    data: recoverIdData,
    error: recoverIdError,
    isLoading: recoverIdLoading,
  } = useRecoverId(
    'useRecoverId' + randoms,
    '',
    form1.email ?? '',
    form1.mobile ?? '',
    form1.countryCode ?? '',
    selectType === 1 ? form1.identityNo ?? '' : '',
    selectType === 0 ? form1.policyNumber ?? '' : '',
    selectType === 0 ? form1.memberId ?? '' : '',
    selectType === 0 ? form1.dependant ?? '' : '',
    shouldPassword ? 'LIFEFP' : selectType === 0 ? 'EBFS' : 'LIFEFS',
    i18n.language,
  );

  const { shouldFetch } = useForgetIdValidatepwd(
    'useForgetIdValidatepwd' + randoms1,
    loginId,
    form1.password ?? '',
    localStorageService.get('deviceId') ?? '',
    'WEB',
    'FL_LOGIN',
    {
      onSuccess: (validateResponse) => {
        shouldFetch(false);
        if (validateResponse) {
          setLoading(false);
          navigate('/forgot/otp-forgot-loginid', {
            state: {
              loginId,
              password: form1.password,
              email: form1.email,
              mobile: form1.mobile,
              countryCode: form1.countryCode,
            },
          });
        }
      },
      onError: (error) => {
        if (error) {
          setLoading(false);
          console.log(error.code, error.message, 'error');
          shouldFetch(false);
          setErrorPwd(error.code);
          const message = setErrorCodeFun(error.code, i18n.language);
          setSnackbarMessage(message ?? (t(error.code) !== error.code ? t(error.code) : 'auth.login.networkError'));
          setOpenSnackbar(true);
        }
      },
    },
  );
  const isShowCaptcha = loginFailCount >= 3;
  const ERROR_UNKNOWN = 'unknown_error';
  const INVALID_GRANT = 'invalid_grant';
  keycloak.onAuthError = (error) => {
    setLoginFailCount((count) => count + 1);
    if (error.error === 'auth.admin.password.expired') {
      setIsAdminModalOpen(true);
      return;
    }
    setSnackbarMessage(error?.error);
    if (error?.error === ERROR_UNKNOWN) {
      setSnackbarMessage('auth.login.generic');
      if (loginFailCount < 2) {
        form.submit();
        return;
      }
    }
    if (error?.error === INVALID_GRANT) {
      setSnackbarMessage('auth.login.invalidGrant');
    }
    setErrorPwd(null);
    setOpenSnackbar(true);
  };
  useEffect(() => {
    if (keycloak.authenticated && tokenParsed?.firstLogin === 'false') {
      navigate(from, { replace: true });
    }
  }, [keycloak.authenticated, tokenParsed?.firstLogin, navigate, from]);
  const handleSubmit = useCallback(
    async (formData: DirectLoginFormData, event?: React.BaseSyntheticEvent) => {
      event && event.preventDefault();
      console.log('onSubmit()->', formData);

      if (!initialized) return;

      if (isShowCaptcha && !isCaptchaVerified) {
        setSnackbarMessage('login.error.captchaError');
        setErrorPwd(null);
        setOpenSnackbar(true);
        return;
      }
      setLoading(true);
      setRandoms1(Math.random());
      shouldFetch(true);
    },
    [initialized, isShowCaptcha, isCaptchaVerified, shouldFetch],
  );
  const onCaptchaError = () => {
    setCaptchaVerified(false);
  };
  // const handleCloseSnackbar1 = () => {
  //   setOpenSnackbar(false);
  // };
  /* eslint-disable */
  useEffect(() => {
    console.log(loginId, 'loginId');
    if (recoverIdData?.message) {
      recoverIdShouldFetch(false);
      setRecoverIdError1('');
      setLoginId(recoverIdData?.message);
    }
    if (!shouldPassword && selectType === 1) {
      if (recoverIdData?.success && recoverIdData.message) {
        // recoverIdShouldFetch(false);
        setShouldPassword(true);
      }
      // } else if (recoverIdData?.errorMessage === 'NoRecord') {
      //   recoverIdShouldFetch(false);
      //   setShouldPassword(false);
      //   setNorecord(true);
      // }
      // return;
    } else if (!shouldPassword && selectType === 0) {
      if (recoverIdData?.success) {
        // recoverIdShouldFetch(false);
        navigate('/forgot/ForgotLoginSuccess', {
          state: {
            countryCode: form1.countryCode,
            type: form1.email ? 'email' : 'phone',
            value: form1.email || form1.mobile,
            loginId: recoverIdData?.message,
            flag: 'EB',
          },
        });
      }
      // else if (recoverIdData?.errorMessage === 'NoRecord') {
      //   recoverIdShouldFetch(false);
      //   setNorecord(true);
      // }
      // return;
    } else if (shouldPassword && forgotBtn) {
      navigate('/forgot/ForgotLoginSuccess', {
        state: {
          countryCode: form1.countryCode,
          type: form1.email ? 'email' : 'phone',
          value: form1.email || form1.mobile,
          loginId: recoverIdData?.message,
          flag: 'Life',
        },
      });
    }
    console.log(recoverIdError, 'recoverIdError-------------');

    if (recoverIdError?.code && recoverIdError?.message) {
      recoverIdShouldFetch(false);
      setErrors(recoverIdError.code);
      setErrorsmsg(recoverIdError.message);
      const message = setErrorCodeFun(recoverIdError.code, i18n.language);
      setRecoverIdError1(message ?? recoverIdError.message);
    }
    // else {
    //   setErrors(null);
    // }
    // if (i18n.language && errors) {
    //   const message = setErrorCodeFun(errors, i18n.language);
    //   setRecoverIdError1(message ?? errorsmsg);
    // }
  }, [recoverIdData, recoverIdError]);
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
    if (errors || errorsmsg) {
      const message = setErrorCodeFun(errors as string, i18n.language);
      setRecoverIdError1(message ?? errorsmsg);
    }
    if (errorPwd) {
      const message = setErrorCodeFun(errorPwd, i18n.language);
      setSnackbarMessage(message ?? (t(errorPwd) !== errorPwd ? t(errorPwd) : 'auth.login.networkError'));
      setOpenSnackbar(true);
    }
  }, [i18n.language, form]);
  /* eslint-enable */

  const handleCloseSnackbar = () => {
    setShowError(false);
    setRecoverIdError1('');
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const closeModel = () => {
    setIsModalVisible(false);
  };

  function onValidateSuccessful(event?: React.BaseSyntheticEvent) {
    event && event.preventDefault();
    setRandoms(Math.random());
    recoverIdShouldFetch(true);
  }
  const onFinish = (val: FormData) => {
    console.log(form1, 'form1--------');
    console.log(val, 'finish--------');
    val.dependant = form1.dependant;
    setForm1({
      ...form1,
      ...val,
      countryCode: form1.countryCode,
    });
    if (shouldPassword && selectType == 1) {
      handleSubmit({ emailId: loginId, password: form1.password });
    } else {
      onValidateSuccessful();
    }
  };
  /* eslint-disable */

  const handleChange = useCallback(
    (value: string, form11) => {
      setForm1({
        ...form11,
        countryCode: value,
      });
      // form.setFieldsValue({
      //   countryCode: value,
      // });
      // dispatch({ type: ActionType.SubmitForm, payload: { ...state, countryCode: value } });
      // eslint-disable-line react-hooks/exhaustive-deps
    },
    [form],
  );
  useEffect(() => {
    handleChange('+852', form1);
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [handleChange]);
  /* eslint-enable */

  const handleTipShow = () => {
    setTipShow(true);
  };
  useEffect(() => {
    if (tipShow) {
      const time = setTimeout(() => {
        setTipShow(false);
        clearTimeout(time);
      }, 3000);
    }
  }, [tipShow]);
  const infoIcon = <InfoCircleOutlined onClick={showModal} style={{ cursor: 'pointer' }} />;
  const identifyNoTip = (
    <Popover
      placement="topLeft"
      content={
        <div style={{ width: '350px' }}>
          <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#6F7072', margin: 0 }}>
            {t('life.forgetLoginId.IdFormats')}
          </p>
          <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B', margin: 0 }}>
            {t('life.forgetLoginId.HKID')}
          </p>
          <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B', margin: 0 }}>
            {t('life.forgetLoginId.HKID2')}
          </p>
          <p style={{ fontFamily: 'Roboto400', fontSize: 17, color: '#420252B', margin: 0 }}>
            {t('registration.logidtooltip')}
          </p>
        </div>
      }
      open={tipShow}
    >
      <InfoCircleOutlined onClick={handleTipShow} style={{ cursor: 'pointer' }} />
    </Popover>
  );
  const [radioValue, setRadioValue] = useState('1');

  const onRadioChange = (e: RadioChangeEvent) => {
    console.log('radio checked', e.target.value);
    setRadioValue(e.target.value);
    setForm1({
      ...form1,
      dependant: e.target.value,
    });
  };
  const [password, setPassword] = useState('');
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(password);
    setForm1({
      ...form1,
      password: e.target.value,
    });
    setPassword(e.target.value);
  };
  const handleForgot = () => {
    setForgotBtn(true);
    setRandoms(Math.random());
    recoverIdShouldFetch(true);
    // navigate('/forgot/ForgotLoginSuccess', {
    //   state: {
    //     countryCode: form1.countryCode,
    //     type: form1.email ? 'email' : 'phone',
    //     value: form1.email || form1.mobile,
    //     loginId: recoverIdData?.message,
    //   },
    // });
  };
  const handleAdminChangeNow = () => {
    setIsAdminModalOpen(false);
    navigate('/update-password', {
      replace: true,
      state: { username: form.getFieldValue('username') },
    });
  };
  useEffect(() => {
    if (!shouldPassword && selectType === 1) {
      if ((form1.email || form1.mobile) && form1.identityNo) {
        setSubmitDisabled(false);
      } else {
        setSubmitDisabled(true);
      }
    } else if (!shouldPassword && selectType === 0) {
      if ((form1.email || form1.mobile) && form1.policyNumber && form1.memberId && form1.dependant) {
        setSubmitDisabled(false);
      } else {
        setSubmitDisabled(true);
      }
    } else if (shouldPassword) {
      if (form1.password) {
        setSubmitDisabled(false);
      } else {
        setSubmitDisabled(true);
      }
    }
  }, [form1, selectType, shouldPassword]);
  return (
    <div
      className={shouldPassword && selectType == 1 ? 'forgot_loginid_wrapper whites' : 'forgot_loginid_wrapper'}
      style={{
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ width: '100%' }}>
        {/* <img src={forgotIcon} alt="forgot-icon" style={{ marginBottom: 12 }} /> */}
        <Typography.Title className="title" level={3} style={{ color: '#fff', marginBottom: 30 }}>
          {t('life.forgetLoginId.headline')}
        </Typography.Title>
      </div>
      <Wrapper
        className="wrapper_login"
        style={{
          borderRadius: '0',
          width: '100%',
          background: '#fff',
          margin: 0,
          padding: 0,
          paddingTop: 20,
          paddingBottom: 20,
        }}
      >
        {isShowError && (
          <Alert
            message={t(snackbarMessage)}
            type="error"
            // closable
            onClose={handleCloseSnackbar}
            style={{ marginBottom: 16 }}
          />
        )}
        <div
          style={{
            paddingBottom: 20,
            backgroundColor: '#fff',
            width: '100%',
            paddingTop: 20,
          }}
        >
          <Typography.Text
            type="secondary"
            className="detailsMsg"
            style={{
              marginLeft: 64,
              marginBottom: 40,
              fontFamily: 'Roboto400',
              color: '#6F7072',
            }}
          >
            {t('life.forgetLoginId.message')}
          </Typography.Text>
        </div>
        <div style={{ backgroundColor: '#fff', width: '100%' }}>
          <Typography.Text
            type="secondary"
            className="mandatory"
            style={{
              marginLeft: 64,
              marginTop: 20,
              color: '#752127',
              fontFamily: 'Roboto400',
            }}
          >
            {t('life.forgetLoginId.mandatory')}
          </Typography.Text>
        </div>
        <Form
          layout={'vertical'}
          form={form}
          onFinish={onFinish}
          style={{
            marginTop: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 0,
            padding: 0,
          }}
          requiredMark="optional"
          validateTrigger={false}
        >
          <Tab
            values={[t('registration.employeeBenefits'), t('life.forgetLoginId.LITab')]}
            selectedIndex={selectType}
            onTabPress={(index) => {
              recoverIdShouldFetch(false);
              setSelectType(index);
              setRecoverIdError1('');
              setSnackbarMessage('');
              setErrorPwd(null);
              setShowError(false);
              setErrors(null);
              setErrorsmsg('');
              setOpenSnackbar(false);
              if (index == 0) {
                setShouldPassword(false);
              }
            }}
          />
          {(!shouldPassword || selectType == 0) && (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  width: '100%',
                  marginTop: '20px',
                  height: '476px',
                }}
                className="select0"
              >
                <div
                  className="step1"
                  style={{
                    backgroundColor: 'white',
                    width: '50%',
                    padding: '30px 30px 0 50px',
                    boxSizing: 'border-box',
                    borderRight: '1px solid #CCCCCC',
                    height: '100%',
                  }}
                >
                  <div className="msg">
                    <Typography.Text
                      type="secondary"
                      style={{
                        height: '25px',
                        lineHeight: '25px',
                        fontSize: '22px',
                        fontFamily: 'Roboto400',
                        color: '#6F7072',
                      }}
                    >
                      {t('life.forgetLoginId.step1')}
                    </Typography.Text>
                  </div>
                  <div
                    style={{
                      height: '98px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Typography.Text
                      className="msg1"
                      type="secondary"
                      style={{ fontSize: '20px', fontFamily: 'Roboto500', color: '#6F7072' }}
                    >
                      {t(`life.forgetLoginId.Enterlifeinsurance`)}
                    </Typography.Text>
                  </div>
                  <Form.Item
                    label={t('life.forgetLoginId.Emailaddress')}
                    name="email"
                    required
                    rules={[
                      {
                        required: !form1.email && !form1.mobile ? true : false,
                        message: t('registration.error.required'),
                      },
                      {
                        validator: (_, value) => {
                          if (value && !VerifyEmail(value)) {
                            return Promise.reject(new Error(t('registration.error.invalidEmail')));
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                    style={{ marginBottom: 12 }}
                  >
                    <Input
                      size="middle"
                      onKeyPress={(e) => {
                        if (e.key === ' ') {
                          e.preventDefault();
                        }
                      }}
                      onChange={(val) => {
                        const inputValue = val.target.value.trim();
                        form.setFieldsValue({ email: inputValue });
                        setForm1({
                          ...form1,
                          email: inputValue,
                        });
                      }}
                      style={{
                        border: 'none',
                        borderBottom: '1px solid #E5E5E5',
                        // color: "white",
                        backgroundColor: 'transparent',
                      }}
                      placeholder={t('life.forgetLoginId.yourEmail')}
                    />
                  </Form.Item>

                  <div
                    className="orMsg"
                    style={{
                      height: '66px',
                      lineHeight: '66px',
                      paddingLeft: 20,
                    }}
                  >
                    <Typography.Text type="secondary">{t('life.forgetLoginId.OR')}</Typography.Text>
                  </div>
                  {/* <Form.Item name="countryCode" noStyle>
                <MobileNumberPrefix handleChange={handleChange} />
              </Form.Item> */}
                  <Form.Item
                    label={t('life.forgetLoginId.MobileNumber')}
                    name="mobileFiled"
                    required
                    className="mobile"
                    style={{
                      marginBottom: 12,
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <Form.Item name={'countryCode'}>
                      <MobileNumberPrefix defaultValue="+852" handleChange={(val) => handleChange(val, form1)} />
                    </Form.Item>
                    <Form.Item
                      name={'mobile'}
                      rules={[
                        {
                          required: !form1.email && !form1.mobile ? true : false,
                          message: t('registration.error.required'),
                        },
                        {
                          validator: (_, value) => {
                            console.log(form1.countryCode, 'countryCode===========');
                            console.log(value, 'mobile===========');
                            if (value && !newVerifyMobileNumber(form1.countryCode, value)) {
                              return Promise.reject(new Error(t('registration.error.invalidMobile')));
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        onChange={(val) => {
                          setForm1({
                            ...form1,
                            mobile: val.target.value,
                          });
                        }}
                        size="middle"
                        style={{
                          border: 'none',
                          borderBottom: '1px solid #E5E5E5',
                          backgroundColor: 'transparent',
                        }}
                        placeholder={t('life.forgetLoginId.PhoneNumber')}
                      />
                    </Form.Item>
                  </Form.Item>
                </div>
                <div
                  className="step2"
                  style={{
                    backgroundColor: 'white',
                    width: '50%',
                    padding: '30px 30px 0 50px',
                    boxSizing: 'border-box',
                    height: '100%',
                  }}
                >
                  <div className="msg">
                    <Typography.Text
                      type="secondary"
                      style={{
                        height: '25px',
                        lineHeight: '25px',
                        fontSize: '22px',
                        fontFamily: 'Roboto400',
                        color: '#6F7072',
                      }}
                    >
                      {t('life.forgetLoginId.Step2')}
                    </Typography.Text>
                  </div>
                  <Typography.Text
                    className="msg1"
                    type="secondary"
                    style={{
                      height: '98px',
                      lineHeight: '98px',
                      fontSize: '20px',
                      fontFamily: 'Roboto500',
                      color: '#6F7072',
                    }}
                  >
                    {selectType == 0 ? t('life.forgetLoginId.ebDetailMsg') : t('life.forgetLoginId.identifyMsg')}
                  </Typography.Text>
                  {selectType == 1 && (
                    <Form.Item
                      label={t('life.forgetLoginId.IDCardPassport')}
                      name="identityNo"
                      className="identityNo"
                      rules={[
                        {
                          required: true,
                          message: t('registration.error.required'),
                        },
                      ]}
                      style={{ marginBottom: 12, color: '#752127' }}
                      tooltip={{ icon: identifyNoTip }}
                    >
                      <Input
                        size="middle"
                        style={{
                          border: 'none',
                          borderBottom: '1px solid #E5E5E5',
                          // color: "white",
                          backgroundColor: 'transparent',
                        }}
                        placeholder={t('life.forgetLoginId.EnterIDnumber')}
                        onChange={(val) => {
                          setForm1({
                            ...form1,
                            identityNo: val.target.value,
                          });
                        }}
                      />
                    </Form.Item>
                  )}
                  {selectType == 0 && (
                    <div>
                      <Form.Item
                        label={t('life.forgetLoginId.policyNumber')}
                        name="policyNumber"
                        className="policyNumber"
                        rules={[
                          {
                            required: true,
                            message: t('registration.error.required'),
                          },
                          // {
                          //   validator: (_, value) => {
                          //     if (value && !verifyPolicyNumber(value)) {
                          //       return Promise.reject(new Error(t('registration.error.invalidPolicyNumber')));
                          //     }
                          //     return Promise.resolve();
                          //   },
                          // },
                        ]}
                        style={{ marginBottom: 20, color: '#752127' }}
                        tooltip={{ icon: infoIcon }}
                      >
                        <Input
                          maxLength={8}
                          size="middle"
                          style={{
                            border: 'none',
                            borderBottom: '1px solid #E5E5E5',
                            // color: "white",
                            backgroundColor: 'transparent',
                          }}
                          placeholder={t('life.forgetLoginId.enterPolicyNumber')}
                          onChange={(val) => {
                            setForm1({
                              ...form1,
                              policyNumber: val.target.value,
                            });
                          }}
                        />
                      </Form.Item>
                      <Form.Item
                        label={t('life.forgetLoginId.memberId')}
                        name="memberId"
                        className="memberId"
                        rules={[
                          {
                            required: true,
                            message: t('registration.error.required'),
                          },
                        ]}
                        style={{ marginBottom: 20, color: '#752127' }}
                        tooltip={{ icon: infoIcon }}
                      >
                        <Input
                          maxLength={12}
                          size="middle"
                          style={{
                            border: 'none',
                            borderBottom: '1px solid #E5E5E5',
                            // color: "white",
                            backgroundColor: 'transparent',
                          }}
                          placeholder={t('life.forgetLoginId.enterMemberId')}
                          onChange={(val) => {
                            setForm1({
                              ...form1,
                              memberId: val.target.value,
                            });
                          }}
                        />
                      </Form.Item>
                      <div className="dependent_forgot">
                        <Form.Item
                          label={t('life.forgetLoginId.dependant')}
                          name="dependant"
                          className="dependant"
                          required
                          // rules={[{ required: true, message: t('registration.error.required') }]}
                          style={{ marginBottom: 12, color: '#752127' }}
                          // tooltip={{ icon: infoIcon }}
                        >
                          <Radio.Group onChange={onRadioChange} defaultValue={'0'} value={radioValue}>
                            <Radio value={'1'}>{t('life.forgetLoginId.Yes')}</Radio>
                            <Radio value={'0'}>{t('life.forgetLoginId.No')}</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <Divider className="divider" style={{ width: '100%', height: 2 }} />
            </>
          )}
          {shouldPassword && selectType == 1 && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
              className="password"
            >
              {/* <Form.Item
                label={t('registration.emailLabel')}
                name="password"
                // rules={[
                //   { required: true, message: t('registration.error.required') },
                // ]}
                style={{ marginBottom: 12 }}
              >
                <Input size="middle" placeholder={'youremail@email.com'} />
              </Form.Item> */}
              <BoldLabelFormItem
                label={<span>{t('life.forgetLoginId.passwordLabel')}</span>}
                name="password"
                style={{ marginTop: 20, fontSize: 17, fontFamily: 'Roboto400' }}
                rules={[
                  {
                    required: true,
                    message: t('registration.error.required'),
                  },
                ]}
              >
                <Input
                  type={visible ? 'text' : 'password'}
                  size="middle"
                  maxLength={12}
                  placeholder={t('life.forgetLoginId.passwordHolder')}
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    // color: "white",
                    backgroundColor: 'transparent',
                  }}
                  onChange={handlePasswordChange}
                  suffix={
                    <span
                      onClick={() => setVisible(!visible)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: 'transparent',
                      }}
                    >
                      {visible ? (
                        <EyeFilled
                          style={{
                            color: '#752127',
                            backgroundColor: 'transparent',
                          }}
                        />
                      ) : (
                        <EyeInvisibleOutlined
                          style={{
                            color: '#752127',
                            backgroundColor: 'transparent',
                          }}
                        />
                      )}
                    </span>
                  }
                />
              </BoldLabelFormItem>
              <Typography.Text
                type="secondary"
                className="detailsMsg"
                style={{ marginLeft: 40, marginBottom: 20, fontSize: 17, fontFamily: 'Roboto400', color: '6F7072' }}
              >
                {t('life.forgetLoginId.forgotTips')}
              </Typography.Text>
            </div>
          )}
          {!shouldPassword && recoverIdError1 && (
            <Alert
              message={recoverIdError1}
              type="error"
              // closable
              className="error-forgot"
              onClose={handleCloseSnackbar}
              style={{ marginBottom: 0 }}
            />
          )}

          {isShowCaptcha && (
            <div style={{ marginTop: 12 }}>
              <GoogleCaptcha
                sitekey={config.captchaSiteKey}
                size="normal"
                theme="light"
                onChange={() => setCaptchaVerified(true)}
                onExpired={onCaptchaError}
                onError={onCaptchaError}
                hl={i18n.language}
              />
            </div>
          )}
          {shouldPassword && selectType == 1 && (
            <Form.Item
              className="btn_form"
              style={
                {
                  // width: '50%',
                }
              }
            >
              <Button
                block
                type="primary"
                // loading={isLoading}
                size="large"
                // htmlType="forgot"
                className="btn"
                style={{
                  marginTop: 16,
                  backgroundColor: 'transparent',
                  color: '#C4211C',
                  width: '428px',
                  height: '56px',
                  lineHeight: '56px',
                  margin: 'auto',
                  padding: 0,
                  fontFamily: 'Roboto400',
                  fontSize: 20,
                }}
                onClick={() => {
                  handleForgot();
                }}
              >
                {t('life.forgetLoginId.ForgotPassword')}
              </Button>
            </Form.Item>
          )}
          {openSnackbar && (
            <Alert
              message={<div className="snackbar" dangerouslySetInnerHTML={{ __html: t(snackbarMessage) }} />}
              type="error"
              // closable
              className="error-forgot"
              onClose={handleCloseSnackbar}
              style={{ marginBottom: 0 }}
            />
          )}
          <Form.Item
            className="btn_form"
            style={
              {
                // width: '50%',
              }
            }
          >
            <Button
              block
              type="primary"
              loading={isLoading || recoverIdLoading}
              size="large"
              htmlType="submit"
              className="btn"
              disabled={submitDisabled}
              style={{
                width: '428px',
                height: '56px',
                lineHeight: '56px',
                margin: 'auto',
                marginTop: 16,
                padding: 0,
                fontFamily: 'Roboto400',
                fontSize: 20,
              }}
              // onClick={()=>{
              //   handleSubmit()
              // }}
            >
              {t('life.forgetLoginId.submit')}
            </Button>
          </Form.Item>
          {/* <Link
            style={{
              fontWeight: 'normal',
              marginLeft: 4,
              marginRight: 4,
              color: '#C21A17',
              textDecoration: 'underline',
            }}
            to="/forgot/login"
          >
            {t('forgetLoginId.help')}
          </Link> */}
        </Form>
      </Wrapper>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
      <Modal
        open={isAdminModalOpen}
        closable={false}
        title={t('admin.password.expired.title')}
        footer={
          <PrimaryButton onClick={() => handleAdminChangeNow()}>{t('admin.password.expired.changeNow')}</PrimaryButton>
        }
      >
        <Trans i18nKey="admin.password.expired.message"></Trans>
      </Modal>
    </div>
  );
}

export default ForgotLoginPage;
